import React, { Component } from 'react';
import RothButton from '../components/RothButton.js';
import RothCheckBox from '../components/RothCheckBox.js';
import FontAwesome from 'react-fontawesome';

import img_perus from '../img/summary_mobile.jpg';

export default class SummaryPage extends Component {
  style = {};
  formatNumber = val => val.toString(10).replace(/[.]/g, ',');
  totalRooms = () => this.props.rooms.length;
  totalPipes = () => this.formatNumber(this.props.response.pipeLength);
  priceEstimate = () => this.formatNumber(this.props.response.price);
  parseNumber = (num, decimals) =>
    parseFloat(num).toLocaleString('sv', { style: 'decimal', minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  componentWillMount = () => {
    console.log('SendData');
    this.props.sendData('createOrUpdate');
  };
  render = () => (
    <div className="content">
      <RothButton type="back" fn={this.props.changePage} param={this.props.backPage} value={this.props.backSubPage}>
        {'← ' + this.props.text('other', 'back')}
      </RothButton>
      <div className="inner">
        <div style={{ padding: '0px 40px' }}>
          <h1 style={{ marginLeft: '0px' }}>{this.props.text('summary', 'h1')}</h1>
          <img src={img_perus} alt={img_perus} style={{ width: '100%' }} />
          <h2>{this.props.text('summary', 'h2')}</h2>
          <div>
            <div>{this.props.optionTexts.heatSource[this.props.project.heatSource]}</div>
            <div>{this.props.optionTexts.cabinet[this.props.project.cabinet]}</div>
            <div>{this.props.optionTexts.manifold[this.props.project.manifold]}</div>
            <div>{this.props.optionTexts.regulationSystem[this.props.project.regulationSystem]}</div>
            <div>{this.props.optionTexts.insulation[this.props.project.insulation]}</div>
          </div>
          <h2>{this.props.text('summary', 'h3')}</h2>
          <div>
            {this.props.rooms.map((room, index) => (
              <div key={index}>
                {room.name}: {this.parseNumber(room.area, 1)} m². {this.props.optionTexts.floorType[room.floorType]}{' '}
                {room.floorType in this.props.optionTexts.system ? this.props.optionTexts.system[room.floorType][room.system] : ''}
              </div>
            ))}
          </div>
          <h2>{this.props.text('summary', 'h4')}</h2>
          {this.props.response.responseStatus === '' || this.props.response.responseStatus === 'waiting' ? (
            <div>
              <FontAwesome name={'spinner fa-pulse fa-3x fa-fw'} />
              <h2 style={{ fontSize: '20px', textAlign: 'left', margin: '30px 30px 30px 0px' }}>{this.props.text('done', 'waiting')}</h2>
            </div>
          ) : (
            <div>
              <div>
                <strong>
                  {this.props.text('summary', 'totalRooms')} {this.parseNumber(this.totalRooms(), 0)}
                </strong>
              </div>
              <div>
                <strong>
                  {this.props.text('summary', 'totalPipes')} {this.parseNumber(this.totalPipes(), 1)} m
                </strong>
              </div>
              <div>
                <strong>
                  {this.props.text('summary', 'priceEstimate')} {this.parseNumber(this.priceEstimate(), 2)} {this.props.currency}
                </strong>
              </div>
            </div>
          )}
          <br />
          <div style={{ display: this.props.showPrintPrices === true ? 'block' : 'none' }}>
            <RothCheckBox param="printPrices" value={this.props.project.printPrices} fn={this.props.changeProjectParam}>
              {this.props.text('summary', 'printPrices')}
            </RothCheckBox>
          </div>
        </div>
        <div />
      </div>
      <RothButton disabled={!this.props.isPageAllowed('customer')} type="wide" fn={this.props.changePage} value="customer">
        {this.props.text('summary', 'accept')}
      </RothButton>
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/views/SummaryPage.js
 **/